export const layerUpdateTimeState = {
  trackTime: {},
  currentScreenRenderTime: null,
  retry: [],
};
